/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import { CalendarRange, Link2, ShieldCheck } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j05-s02-apresentar-vinculo';
export function ResponsavelVinculosPage() {
  const [s, setS] = useState<any>(),
    [d, setD] = useState<any>({
      recursoTipo: 'VEICULO',
      tipoVinculo: 'PROPRIEDADE',
      inicio: new Date().toISOString().slice(0, 10),
      fim: '2027-12-31',
    }),
    key = useRef(crypto.randomUUID());
  async function call(p: string, b?: unknown) {
    const x = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
    setS(x.state);
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando vínculos…
      </main>
    );
  const recursos = s.recursos.filter((r: any) => r.tipo === d.recursoTipo);
  return (
    <main className="mx-auto max-w-4xl space-y-5 px-4 py-6">
      <header>
        <p className="text-sm text-muted-foreground">J-05 · Frota e equipe</p>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {s.alertas.map((a: any, i: number) => (
        <div role="alert" className="rounded-md border border-destructive p-3" key={i}>
          {a.mensagem}
        </div>
      ))}
      <section className="grid gap-3 rounded-md border p-4">
        <h2 className="font-semibold">
          <Link2 className="mr-2 inline h-5 w-5" />
          Apresentar vínculo
        </h2>
        <label>
          Tipo de recurso
          <select
            className="mt-1 w-full rounded-md border bg-background p-2"
            value={d.recursoTipo}
            onChange={(e) => setD({ ...d, recursoTipo: e.target.value, recursoId: '' })}
          >
            <option>VEICULO</option>
            <option>CONDUTOR</option>
            <option>MONITOR</option>
          </select>
        </label>
        <label>
          Recurso
          <select
            className="mt-1 w-full rounded-md border bg-background p-2"
            value={d.recursoId ?? ''}
            onChange={(e) => setD({ ...d, recursoId: e.target.value })}
          >
            <option value="">Selecione</option>
            {recursos.map((r: any) => (
              <option value={r.id} key={r.id}>
                {r.identificador}
              </option>
            ))}
          </select>
        </label>
        <label>
          Relação
          <input
            className="mt-1 w-full rounded-md border bg-background p-2"
            value={d.tipoVinculo}
            onChange={(e) => setD({ ...d, tipoVinculo: e.target.value })}
          />
        </label>
        <div className="grid gap-3 sm:grid-cols-2">
          <label>
            Início
            <input
              type="date"
              className="mt-1 w-full rounded-md border bg-background p-2"
              value={d.inicio}
              onChange={(e) => setD({ ...d, inicio: e.target.value })}
            />
          </label>
          <label>
            Fim
            <input
              type="date"
              className="mt-1 w-full rounded-md border bg-background p-2"
              value={d.fim}
              onChange={(e) => setD({ ...d, fim: e.target.value })}
            />
          </label>
        </div>
        <label>
          CPF do titular
          <input
            inputMode="numeric"
            className="mt-1 w-full rounded-md border bg-background p-2"
            onChange={(e) => setD({ ...d, titularCpf: e.target.value })}
          />
        </label>
        <label>
          Nome do titular
          <input
            className="mt-1 w-full rounded-md border bg-background p-2"
            onChange={(e) => setD({ ...d, titularNome: e.target.value })}
          />
        </label>
        <label>
          E-mail do titular
          <input
            type="email"
            className="mt-1 w-full rounded-md border bg-background p-2"
            onChange={(e) => setD({ ...d, titularEmail: e.target.value })}
          />
        </label>
        <Button
          disabled={!d.recursoId}
          onClick={() => void call('/verbs/apresentar', { ...d, chaveIdempotencia: key.current })}
        >
          Gerar convite de confirmação
        </Button>
        {s.resultado?.convite && (
          <a className="break-all text-link underline" href={s.resultado.convite}>
            Abrir convite do titular
          </a>
        )}
      </section>
      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Histórico de vínculos</h2>
        {s.vinculos.map((v: any) => (
          <article className="rounded-md border p-4" key={v.id}>
            <p className="font-medium">
              {v.recursoTipo} · {v.tipoVinculo}
            </p>
            <p>
              <CalendarRange className="mr-2 inline h-4 w-4" />
              {v.inicio} a {v.fim}
            </p>
            <p>
              {v.titularNome} · {v.titularDocumento} · {v.status}
            </p>
          </article>
        ))}
      </section>
    </main>
  );
}
const NT = '/bff/v1/j05-s02-confirmar-titular';
export function TitularVinculoRecursoPage() {
  const token = new URLSearchParams(location.search).get('token') ?? '',
    [s, setS] = useState<any>(),
    [motivo, setMotivo] = useState('Não reconheço esta relação.');
  async function call(p: string, b: unknown = { token }) {
    const x = await chamarApi<any>(NT + p, {
      metodo: p === '/state' ? 'GET' : 'POST',
      corpo: p === '/state' ? undefined : b,
      publica: true,
      credenciais: true,
    });
    setS(x.state);
  }
  useEffect(() => {
    void chamarApi<any>(`${NT}/state?token=${token}`, { publica: true, credenciais: true }).then(
      (x) => setS(x.state),
    );
  }, [token]);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando convite…
      </main>
    );
  return (
    <main className="mx-auto max-w-3xl space-y-5 px-4 py-8">
      <header>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {s.alertas.map((a: any, i: number) => (
        <div role="alert" className="rounded-md border p-3" key={i}>
          {a.mensagem}
        </div>
      ))}
      {s.vinculo && (
        <section className="rounded-md border p-4">
          <h2 className="font-semibold">
            <ShieldCheck className="mr-2 inline h-5 w-5" />
            {s.vinculo.recursoTipo} · {s.vinculo.tipoVinculo}
          </h2>
          <p>Recurso: {s.vinculo.recursoId}</p>
          <p>
            Período: {s.vinculo.inicio} a {s.vinculo.fim}
          </p>
          <p>
            Titular: {s.vinculo.titularNome} · {s.vinculo.titularDocumento}
          </p>
          <p>Status: {s.vinculo.status}</p>
        </section>
      )}
      {s.fase === 'CONVITE_VALIDO' && (
        <Button onClick={() => void call('/verbs/iniciar_identificacao')}>
          Identificar com gov.br
        </Button>
      )}
      {s.fase === 'AGUARDANDO_IDENTIDADE' && !s.identidade?.confirmada && (
        <Button onClick={() => void call('/verbs/reconciliar_identificacao')}>
          Já confirmei minha identidade
        </Button>
      )}
      {s.identidade?.confirmada && s.vinculo.status === 'PENDENTE' && (
        <section className="grid gap-3">
          <p>
            Identidade confirmada: {s.identidade.nome} · nível {s.identidade.nivel}
          </p>
          <label>
            Motivo da recusa
            <input
              className="mt-1 w-full rounded-md border bg-background p-2"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            />
          </label>
          <div className="flex flex-wrap gap-2">
            <Button
              onClick={() => void call('/verbs/decidir', { token, decisao: 'ACEITAR', motivo: '' })}
            >
              Aceitar vínculo
            </Button>
            <Button
              variant="outline"
              onClick={() => void call('/verbs/decidir', { token, decisao: 'RECUSAR', motivo })}
            >
              Recusar vínculo
            </Button>
          </div>
        </section>
      )}
    </main>
  );
}
